import { useParams } from "react-router-dom"

import useGetMotibellLanding from "hooks/queries/motibell/useGetMotibellLandingQuery"
import { useMemo } from "react"

const useMotibellLanding = () => {
  const { motibellNo } = useParams()

  const { data: landingData, isLoading } = useGetMotibellLanding(
    { motibellNo },
    { enabled: !!motibellNo }
  )

  const landingDescData = useMemo(() => {
    if (!landingData) return null
    return landingData.data.landing.descriptions
  }, [landingData])

  return { landingDescData, isLoading }
}

export default useMotibellLanding
